function cardHeading () {
  if ( document.querySelectorAll(".product-card .product-card__title").length > 0 ){
   var heading = document.querySelectorAll(".product-card .product-card__title");
    var titleHeight = 0;
    heading.forEach( title => {    
      var matchHeight = title.clientHeight;
      if( matchHeight > titleHeight ){
        titleHeight = title.clientHeight;
      }
    }); 
    heading.forEach( divHeight => {
      divHeight.style.minHeight = titleHeight + "px";
    }); 
  }
}
document.addEventListener("DOMContentLoaded", function() {
  cardHeading ();    
});

var reviews = document.querySelector('.stamped-product-reviews-badge');
if(reviews != null) {
  reviews.addEventListener("click", function(event){
    document.querySelector(".section-blends.section-full .shopify-block.shopify-app-block").scrollIntoView();
  });
}
